import {BaseModel} from "./BaseModel";

export class Document extends BaseModel{
    static entity = 'Household\\Model\\Document';
    static modelKey = 'documents';

    static fields() {
        return {
            id: this.attr(null),
            file_file_name: this.attr(null),
            file_content_type: this.attr(''),
            file_file_size: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(true)
        }
    }
}
